
import styled, { createGlobalStyle } from 'styled-components';
import openSans200 		from './fonts/opensans-200.ttf';
import openSans300 		from './fonts/opensans-300.ttf';
import openSans400 		from './fonts/opensans-400.ttf';
import openSans600 		from './fonts/opensans-600.ttf';
import Logo 			from './images/logo.svg';

import Breadcrumb 		from './images/breadcrumb.svg';
import ArrowUpload 		from './images/upload.svg';
import CreateFolder 	from './images/create-folder.svg';
import Close 			from './images/close.svg';
import CloseHover 		from './images/close_hover.svg';

import IconFolder 		from './images/folder.svg';
import IconVideo 		from './images/video.svg';
import IconVideoActive 	from './images/video_active.svg';
import IconAudio 		from './images/audio.svg';
import IconImage 		from './images/image.svg';
import IconFile 		from './images/file.svg';

import CheckBox 		from './images/check.svg';
import CheckBoxActive 	from './images/check_active.svg';
import CheckBoxDisabled from './images/check_disabled.svg';

import Download 		from './images/download.svg';
import DownloadHover 	from './images/download_hover.svg';

import Delete 			from './images/delete.svg';
import DeleteHover 		from './images/delete_hover.svg';

import PlaybackNext			from './images/playback/next.svg';
import PlaybackNextHover	from './images/playback/next_hover.svg';
import PlaybackNextPush		from './images/playback/next_push.svg';
import PlaybackPlay			from './images/playback/play.svg';
import PlaybackPlayActive	from './images/playback/play_active.svg';
import PlaybackPlayHover	from './images/playback/play_hover.svg';
import PlaybackPlayPush		from './images/playback/play_push.svg';
import PlaybackPrev			from './images/playback/prev.svg';
import PlaybackPrevHover	from './images/playback/prev_hover.svg';
import PlaybackPrevPush		from './images/playback/prev_push.svg';
import PlaybackRecord		from './images/playback/record.svg';
import PlaybackRecordActive	from './images/playback/record_active.svg';
import PlaybackStop			from './images/playback/stop.svg';
import PlaybackStopHover	from './images/playback/stop_hover.svg';
import PlaybackStopPush		from './images/playback/stop_push.svg';


export default createGlobalStyle `
	@font-face {
		font-family: 'opensans light';
		font-style: normal;
		font-weight: 200;
		src: url(${openSans200});
	}

	@font-face {
		font-family: 'openSans regular';
		font-style: normal;
		font-weight: 300;
		src: url(${openSans300});
	}

	@font-face {
		font-family: 'opensans semibold';
		font-style: normal;
		font-weight: 400;
		src: url(${openSans400});
	}

	@font-face {
		font-family: 'opensans bold';
		font-style: normal;
		font-weight: 600;
		src: url(${openSans600});
	}

	* {
		margin: 0;
		padding: 0;
		outline: 0;
		box-sizing: border;
		font-family: 'opensans regular', sans-serif;
	}

	body {
		background: #000;
		-webkit-font-smoothing: antialiased;
	}
`

export const AppWrapper = styled.div `
	position: relative;
	display: block;
	width: auto;
	height: 100vh;
`

export const Container = styled.div `
	position: relative;
	display: table;
	width: 100%;
	min-width: 1200px;
	height: 100%;
	background-color: #fff;
	margin: 0 auto;

	.overlay {
		display: none;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background-color: rgba(0,0,0,0.2);
		z-index: 10;

		&.show {
			display: table;
		}

		.popup {
			position: absolute;
			min-width: 500px;
			height: 192px;
			background-color: #fff;
			border-radius: 6px;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			-webkit-box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.5);
			box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.5);

			&.create-folder {
				height: 215px;

				.button {
					top: 155px;

					&.cancel {
						height: 27px;
						right: 164px;
						width: 110px;
					}

					&.delete {
						height: 31px;
						right: 30px;
						width: 114px;
					}
				}
			}

			h3 {
				position: absolute;
				top: 45px;
				left: 30px;
				font-family: 'opensans semibold';
				font-size: 18px;
				color: #474747;

				&.error {
					color: #D0021B;
				}
			}

			p {
				position: absolute;
				top: 74px;
				left: 30px;
				font-family: 'opensans regular';
				font-size: 13px;
				color: #474747;

				span {
					font-family: 'opensans semibold';
				}
			}

			input[type="text"] {
				position: absolute;
				top: 79px;
				left: 30px;
				width: 429px;
				height: 35px;
				padding: 0 0 0 10px;
				border: 1px solid rgba(0,141,255,1);
				border-radius: 4px;
			}

			.upload-progress-bar {
				position: absolute;
				top: 86px;
				left: 30px;
				width: 440px;
				height: 6px;
				border-radius: 5px;
				background-color: #D8D8D8;
				overflow: hidden;

				@keyframes mymove {
					0%   {width: 0%;}
					25%  {width: 40%;}
					75%  {width: 60%}
					100% {width: 100%;}
				}

				.progress {
					position: absolute;
					top: 0;
					left: 0;
					width: ${(props) => props.completed ? props.completed : "0%"};
					height: 6px;
					background-color: rgba(0,141,255,1);
					transition: .3s;

					&.active {
						animation: mymove 4s linear;
						width: 100%;
					}
				}
			}

			.close {
				position: absolute;
				top: 15px;
				right: 15px;
				width: 30px;
				height: 30px;
				background-image: url(${Close});
				background-position: center;
				background-repeat: no-repeat;
				cursor: pointer;
				transition: .3s;

				&:hover {
					background-image: url(${CloseHover});
				}
			}

			.button {
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				top: 132px;
				width: 114px;
				height: 30px;
				font-family: 'opensans semibold';
				font-size: 13px;
				border-radius: 10px;
				cursor: pointer;
				transition: .3s;

				&.cancel, &.ok {
					width: 110px;
					height: 27px;
					right: 164px;
					border: 2px solid rgba(0,0,0,.4);
					color: #000;
					text-align: center;

					&:hover {
						opacity: .6;
					}

					&:active {
						background-color: rgba(0,0,0,.4);
					}
				}

				&.ok {
					right: 30px;
				}

				&.delete {
					right: 30px;
					height: 31px;
					background-color: rgba(0,141,255,1);
					color: #fff;

					&:hover {
						background-color: rgba(0,141,255,0.6);
					}

					&:active {
						background-color: #005599;
					}
				}
			}
		}
	}

	.header {
		position: relative;
		display: table;
		width: 100%;
		height: 70px;
		margin: 0 auto;
		background-color: #27282B;

		h1 {
			display: block;
			position: absolute;
			top: 20px;
			left: 29px;
			font-family: 'openSans light';
			font-size: 22px;
			color: #fff;
			text-align: center;
		}

		.logo {
			content: '';
			position: absolute;
			top: 12px;
			right: 31px;
			width: 147px;
			height: 46px;
			background-image: url(${Logo});
			background-repeat: no-repeat;
			background-size: 147px 46px;
		}
	}

	.top-bar {
		position: relative;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		align-items: center;
		width: calc(100% - 152px);
		height: 40px;
		margin: 25px auto 14px auto;

		.breadcrumb-container {
			display: flex;

			span {
				display: flex;
				align-items: center;
				height: 40px;
				font-family: 'opensans semibold';
				font-size: 22px;
				color: #7A7A7A;

				&.current {
					color: #000;
				}

				&.active {
					cursor: pointer;

					&:hover {
						color: #008DFF;
					}
				}
			}

			.breadcrumb {
				display: block;
				width: 20px;
				height: 40px;
				background-image: url(${Breadcrumb});
				background-size: 30px;
				background-position: center;
				background-repeat: no-repeat;
			}
		}

		.buttons-container {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			height: 100%;

			.btn-upload {
				position: relative;
				width: 130px;
				height: 30px;
				margin: 0 0 0 0;
				background-image: url(${ArrowUpload});
				background-repeat: no-repeat;
				background-position: 13px 6px;
				background-color: #008DFF;
				border-radius: 10px;
				overflow: hidden;
				transition: .3s;

				&:before {
					content: 'Upload';
					position: absolute;
					top: 6px;
					right: 31px;
					font-family: 'opensans semibold';
					font-size: 13px;
					color: #fff;
				}

				&:hover {
					background-color: rgba(0,141,255,0.6);
				}

				&:active {
					background-color: #005599;
				}

				.input {
					opacity: 0
				}
			}

			.btn-create-folder {
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				width: 119px;
				height: 26px;
				margin: 0 0 0 10px;
				padding: 0 7px 0 0;
				font-family: 'openSans semibold';
				font-size: 13px;
				background-image: url(${CreateFolder});
				background-repeat: no-repeat;
				background-position: 10px 6px;
				border: 2px solid rgba(0,0,0,.4);
				border-radius: 10px;
				overflow: hidden;
				cursor: pointer;
				transition: .3s;
			}
		}
	}

    .loading-content {
        display: block;
		margin-left: auto;
		margin-right: auto;
    }

	.content {
		display: grid;
		grid-template-columns: repeat(1, 1fr);
		grid-auto-rows : 45px;
		height: auto;
		margin: 0 76px 110px 76px;
		overflow: auto;

        > .spinner {
            margin-left: auto;
            margin-right: auto;
            fill: #008DFF;
            height: 60px;
            width: 60px;
            margin-top: 20px;
        }

		> .mini-header {
			display: grid;
			grid-template-columns: 50% 20% 30%;
			align-items: center;

			span {
				display: block;
				float: left;
				font-family: 'opensans bold';
				font-size: 14px;

				&:nth-child(1) { padding: 0 0 0 15px; }

				&:nth-child(2) { text-align: center; }
			}
		}

		> div.item {
			display: grid;
			grid-template-columns: 50% 20% 30%;
			align-items: center;
			border-bottom: 1px solid #ECECEC;
			cursor: default;

			&.active {
				background-color: #F3FAFF;

				span {
					font-family: 'opensans semibold';

					&:nth-child(2) {
						color: #1998FF;
					}
				}
			}

			.icons-type {
				width: 30px;
				height: 30px;
				float: left;
				margin: 0 6px 0 0;
				background-repeat: no-repeat;
				background-position: center;

				&.mov, &.mp3, &.png, &.txt, &.folder {
					margin: 0 0 0 0;
					width: 45px;
				}

				&.mov {
					background-image: url(${IconVideo});

					&.active {
						background-image: url(${IconVideoActive});
					}
				}

				&.mp3 { background-image: url(${IconAudio}); }

				&.png { background-image: url(${IconImage}); }

				&.txt { background-image: url(${IconFile}); }

				&.folder { background-image: url(${IconFolder}); }

				&.play {
					background-image: url(${PlaybackPlay});
					background-size: 38px;

					&.active {
						background-image: url(${PlaybackPlayActive});
					}
				}

				&.stop {
					background-image: url(${PlaybackStop});
					background-size: 38px;

					&.active {
						background-image: url(${PlaybackStop});
					}
				}
			}

			.pretty {
				width: 30px;
				height: 30px;
				margin: 0 0 0 0;

				.state label {
					width: 30px;
				}

				.p-default input:checked~.state label:after {
					width: 30px;
					height: 30px;
					border-radius: 0;
					border: 0;
					background-image: url(${CheckBoxActive});
					background-color: transparent!important;
				}

				.state label:before {
					width: 30px;
					height: 30px;
					border-radius: 0;
					border: 0;
					background-image: url(${CheckBox});
				}

				.state label:after, .state label:before {
					top: 0;
				}
			}

			.icons-action {
				display: block;
				width: 80px;
				height: 30px;
				margin: 0 10px 0 0;

				.download {
					width: 30px;
					height: 30px;
					background-image: url(${Download});
					background-size: 30px;
					background-position: 5px 6px;
					background-repeat: no-repeat;
					float: left;
					color: transparent;

					&:hover		{ background-image: url(${DownloadHover}); }
				}

				.delete {
					width: 30px;
					height: 30px;
					background-image: url(${Delete});
					background-size: 30px;
					background-position: 5px 4px;
					background-repeat: no-repeat;
					float: right;
					cursor: pointer;

					&:hover 	{ background-image: url(${DeleteHover}); }
				}
			}

			div {
				display: flex;
				align-items: center;
				height: 40px;

				&:nth-child(2) { justify-content: center; }

				&:nth-child(3) { justify-content: space-between; }

				span {
					font-family: 'opensans regular';
					font-size: 13px;
					color: #000;
					margin: 0 0 0 0;
				}
			}

			&:hover {

				span {
					font-weight: 300;
				}

				transition: 0.4s;
				background-color: #EFEFEF;

				&:first-child {
					background-color: #fff;
					color: #000;
				}
			}
		}
	}

	.playback-controls {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		left:0;
		bottom: 0;
		width: 100%;
		height: 100px;
		background-color: #fff;
		-webkit-box-shadow: 0px -1px 15px 0px rgba(0,0,0,0.14);
		box-shadow: 0px -1px 15px 0px rgba(0,0,0,0.14);
		border-top: 1px solid #D8D8D8;

		.playback-icon {
			display: inline-block;
			width: 50px;
			height: 50px;
			background-repeat: no-repeat;
			background-size: 50px;

			&.prev 	{
				background-image: url(${PlaybackPrev});
				margin: 0 40px 0 76px;

				&:hover 	{ background-image: url(${PlaybackPrevHover}); }
				&:active 	{ background-image: url(${PlaybackPrevPush}); }
			}

			&.next 	{
				background-image: url(${PlaybackNext});
				margin: 0 40px 0 0;

				&:hover 	{ background-image: url(${PlaybackNextHover}); }
				&:active 	{ background-image: url(${PlaybackNextPush}); }
			}

			&.play 	{
				background-image: url(${PlaybackPlay});
				margin: 0 40px 0 0;

				&.active 	{ background-image: url(${PlaybackPlayActive}); }
				&:hover 	{ background-image: url(${PlaybackPlayHover}); }
				&:active 	{ background-image: url(${PlaybackPlayPush}); }
			}

			&.stop 	{
				background-image: url(${PlaybackStop});

				&:hover 	{ background-image: url(${PlaybackStopHover}); }
				&:active 	{ background-image: url(${PlaybackStopPush}); }
			}

			&.rec 	{
				background-image: url(${PlaybackRecord});

				&.active 	{ background-image: url(${PlaybackRecordActive}); }
			}
		}
	}
`
